import consoleLog from './consoleLogger';
import SmartLogger from './smartLogger';

const log = {
    setLevel: (consoleLogLevel, awsLoggerLevel) => {
        const smartLogger = new SmartLogger();

        consoleLog.setLevel(consoleLogLevel);
        smartLogger.setLevel(awsLoggerLevel);
    },
    debug: (msg, options) => {
        const smartLogger = new SmartLogger();

        consoleLog.debug(msg);
        smartLogger.debug(msg, options);
    },
    info: (msg, options) => {
        const smartLogger = new SmartLogger();

        consoleLog.info(msg);
        smartLogger.info(msg, options);
    },
    error: (msg, options) => {
        const smartLogger = new SmartLogger();

        consoleLog.error(msg);
        smartLogger.error(msg, options);
    },
    fatal: (msg, options) => {
        const smartLogger = new SmartLogger();

        consoleLog.error(msg);
        smartLogger.fatal(msg, options);
    },
    resetLogger: () => {
        const smartLogger = new SmartLogger();

        smartLogger.resetLogger();
    },
};

export default log;
